import React from 'react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {connect} from 'react-redux';
import _ from 'lodash';
import {UpdateEntityWrapper} from 'go/components/dynamic/modules/form/submitWrappers/UpdateEntityWrapper';
import {compileContent} from 'common/utils';
import {produce} from 'immer';
import {ContentDispatch} from 'framework';

export const transformEntities = (entitySaveOptions, props) => {
  const clonedEntities = produce(entitySaveOptions, (draft) => {
    _.forEach(draft, (entityOptions, index) => {
      let {entity, toChange} = entityOptions;

      _.forEach(toChange, (update) => {
        const type = update.type || 'template';
        let value = update.value;
        if (type == 'template') {
          value = compileContent(update.value, props);
        } else if (type == 'propsPath') {
          value = _.get(props, update.value);
        }
        _.set(entity, update.dataPath, value);
      });
    });
  });

  return clonedEntities;
};

export const convertToNewFormat = (
  entityToSave,
  saveOnSubmit,
  entities,
  dependencies
) => {
  // backwards compatibility for the 28 configurations using this (2018 pre and post award)
  if (entityToSave) {
    const entityDataPath = _.get(
      _.find(dependencies, (dep) => dep.entityToSave !== undefined),
      'entityToSave'
    );
    const entityType = entityToSave.entityType;
    const entity = {
      entityDataPath,
      entityType,
      toChange: saveOnSubmit,
      entity: entityToSave,
    };

    return [entity];
  }

  return entities;
};

export const UpdateSubmitButton = (props) => {
  const {
    saveOnSubmit,
    handleSubmit,
    entityToSave,
    entities,
    token,
    saveEntitySessionData,
    dependencies,
    childSubmitButton,
    childSubmitButtonConfig,
    getAuthentication
  } = props;

  let getEntity;

  const entitiesConverted = convertToNewFormat(
    entityToSave,
    saveOnSubmit,
    entities,
    dependencies
  );

    getEntity = () => transformEntities(entitiesConverted, props);


  // use childSubmitButtonConfig, or if it doesn't exist, use childSubmitButton string, or if it doesn't have either prop, use 'DynamicSubmitButton'
  const buttonConfig = _.has(childSubmitButtonConfig, 'type')
    ? childSubmitButtonConfig
    : {type: childSubmitButton || 'DynamicSubmitButton'};

  const propsToPass = {
    ...props,
    childSubmitButton: undefined, // prevent child from rendering itself infinitely when passed childSubmitButton
    childSubmitButtonConfig: _.get(buttonConfig, 'childSubmitButtonConfig'),
    config: {
      ...props.config,
      ...buttonConfig,
    },
  };

  return (
    <UpdateEntityWrapper
      getEntity={getEntity}
      token={token}
      handleSubmit={handleSubmit}
      getAuthentication={getAuthentication}
      saveEntitySessionData={saveEntitySessionData}
    >
      {(updateHandleSubmit, ...otherArgs) => (
        <ContentDispatch
          {...propsToPass}
          {...otherArgs}
          handleSubmit={updateHandleSubmit}
        />
      )}
    </UpdateEntityWrapper>
  );
};

export const mapStateToProps = (state, props) => {
  const entitiesToSave = _.get(props, 'entitiesToSave', []);
  const entities = _.map(entitiesToSave, (entity) => ({
    entity: _.get(state.dynamicComponent, entity.entityDataPath),
    entityDataPath: entity.entityDataPath,
    entityType: entity.entityType,
    toChange: entity.toChange,
  }));

  return {
    token: _.get(state, 'auth.token'),
    entities,
  };
};

export const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(connectDynamic(UpdateSubmitButton));
